import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { INVALID_ADDRESS_RESPONSE_CONTRACT, validateAddressList } from "@/main/services/addressContract";

// Redux
import { saveBillingAddress } from "./billingAddressActions";
import type { GetBillingAddress } from "./billingAddressTypes";

// Api's
import { addressApi } from "../../api";
import { AddressByBodyshopResponse } from "@/main/models/response";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getBillingAddressSaga(action: GetBillingAddress) {
	try {
		const response: AxiosResponse<Result<AddressByBodyshopResponse[]>> = yield call(
			addressApi.getBillingAddressSummary,
			action.payload.request,
		);
		validateAddressList(response.data?.result);
		yield put(saveBillingAddress(response.data.result, false, null));
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveBillingAddress(null, true, resultError.messagesDataError));
		} else {
			yield put(saveBillingAddress(null, true, [INVALID_ADDRESS_RESPONSE_CONTRACT]));
		}
	}
}
